import { render } from "./RenameDialog.vue?vue&type=template&id=7a989134&scoped=true"
import script from "./RenameDialog.vue?vue&type=script&lang=js"
export * from "./RenameDialog.vue?vue&type=script&lang=js"

import "./RenameDialog.vue?vue&type=style&index=0&id=7a989134&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a989134"]])

export default __exports__